import React, { useEffect } from 'react';
import { css } from '@emotion/react';
import {
	QUERY_REQUEST_DATA,
	QUERY_REQUEST_STATE,
	MUTATION_UPDATE_DATA_FEE,
	QUERY_ARTISTS,
} from 'queries/queries-booking';
import { Controller, useForm } from 'react-hook-form';

import { useMutation, useQuery } from 'urql';
import { Button } from '../../../components/Button';
import { FormControl } from '../../../components/FormControl';
import { FormFooter } from '../../../components/FormFooter';
import { FormLine } from '../../../components/FormLine';
import { FormSectionHeading } from '../../../components/FormSectionHeading';
import { Heading } from '../../../components/Heading';
import { Input } from '../../../components/Input';
import { Radios } from '../../../components/Radios';
import { emailValidation, nonEmptyValidation } from '../forms/validations';
import { useStep } from '../hooks/useStep';
import { confirmedRedirect } from '../helpers/helpers';
import { useNavigate } from 'react-router-dom';
import { IconEmail } from 'icons/icon-email';

import { InputPrice } from 'components/InputPrice';
import { PrefilledValuePrice } from '../components/PrefilledValuePrice';

import { SpinnerBlock } from 'components/SpinnerBlock';

import { PriceSummary } from '../components/PriceSummay';
import { useStore } from 'hooks/useStore';
import { Textarea } from 'components/Textarea';
import { PreffiledValue } from '../components/PreffiledValue';
import { useRequestStateQuery } from 'generated/graphql';

enum FORM_FEE {
	TYPE = 'fee_type',
	AMOUNT = 'fee_amount',
	TRAVEL = 'fee_travel',
	OTHER = 'fee_other',
	PAYMENT_TYPE = 'fee_payment_type',
	PAYING_NAME = 'fee_paying_name',
	PAYING_EMAIL = 'fee_paying_email',
}

export enum FEE_TYPE {
	FIXED = 'FEE_FIXED',
	OTHER = 'FEE_OTHER',
}

export const FeeStep = () => {
	const { id } = useStep();
	const navigate = useNavigate();

	const [queryRequestData] = useQuery({
		query: QUERY_REQUEST_DATA,
		variables: {
			url: id,
		},
	});

	const [_stateRequest] = useRequestStateQuery({
		variables: { url: id },
	});

	const [artistData] = useQuery({
		query: QUERY_ARTISTS,
		variables: {
			url: queryRequestData?.data?.request?.artist?.id,
		},
	});

	useEffect(() => {
		if (!queryRequestData.fetching) {
			confirmedRedirect(id, queryRequestData.data.request.confirmed, navigate);
		}
	}, [queryRequestData.data]);

	return (
		<div
			css={css`
				width: 560px;
			`}
		>
			<Heading title="Honorář" />

			{queryRequestData.fetching ? (
				<SpinnerBlock />
			) : (
				<Form defaultValues={queryRequestData?.data?.request} url={id} />
			)}
		</div>
	);
};

const Form = ({ defaultValues, url }) => {
	const { notifications } = useStore();

	const { goNextStep, goPrevStep } = useStep();

	const localDefaultValues = {
		fee_type: defaultValues?.fee_type ? defaultValues?.fee_type : FEE_TYPE.FIXED,

		fee_amount: defaultValues?.fee_amount,
		fee_travel: defaultValues?.fee_travel,

		fee_other: defaultValues?.fee_other,

		fee_payment_type: defaultValues?.fee_payment_type,
		fee_paying_name: defaultValues?.fee_paying_name,
		fee_paying_email: defaultValues?.fee_paying_email,
	};

	const {
		handleSubmit,
		register,
		control,
		formState: { errors },
		getValues,
		watch,
	} = useForm({ defaultValues: localDefaultValues });

	// Submit Form
	const [updateDataFee, executeUpdateDataFee] = useMutation(MUTATION_UPDATE_DATA_FEE);

	const onSubmit = (data: any) => {
		// console.log('SUBMIT');
		// console.log(data);

		executeUpdateDataFee({
			url: url,
			input: data,
		}).then((result) => {
			// console.log(result);

			if (result?.error) {
				// VYHODIT ERROR
				return false;
			} else {
				notifications.addNotification({ message: 'Uloženo' });
			}

			goNextStep();
		});
	};

	const labelWidth = 178;

	const paymentTypeOptions = [
		{ label: 'Faktura', value: 'PAYMENT_INVOICE' },
		{ label: 'Hotovost', value: 'PAYMENT_CASH' },
	];

	const feeType = watch(FORM_FEE.TYPE);

	const feeAmount = watch(FORM_FEE.AMOUNT);
	const feeTravel = watch(FORM_FEE.TRAVEL);

	const priceTotal = feeAmount + feeTravel;

	const feeTypeOptions = [
		{
			label: 'Fixní',
			value: FEE_TYPE.FIXED,
		},
		{ label: 'Jiné podmínky', value: FEE_TYPE.OTHER },
	];

	const feeTypeValue = feeTypeOptions.find((option) => option.value === feeType);

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<FormLine first noPaddingBottom>
				<FormControl
					label="Typ"
					htmlFor={FORM_FEE.TYPE}
					labelWidth={labelWidth}
					error={errors[FORM_FEE.TYPE]}
				>
					<PreffiledValue noPadding>{feeTypeValue?.label}</PreffiledValue>
					{/* {!defaultValues.prefilled ? (
						<Controller
							name={FORM_FEE.TYPE}
							control={control}
							defaultValue={feeTypeOptions[0].value}
							render={({ field }) => {
								return <Radios options={feeTypeOptions} {...field} />;
							}}
						/>
					) : (
						<PreffiledValue noPadding>{feeTypeValue?.label}</PreffiledValue>
					)} */}
				</FormControl>
			</FormLine>

			{feeType === FEE_TYPE.FIXED && (
				<>
					<FormLine>
						<FormControl
							required
							label="Honorář"
							htmlFor={FORM_FEE.AMOUNT}
							labelWidth={labelWidth}
							error={errors[FORM_FEE.AMOUNT]}
							value={defaultValues?.fee_amount}
						>
							<PrefilledValuePrice
								price={defaultValues[FORM_FEE.AMOUNT]}
								isVAT={defaultValues.fee_vat}
							/>
							{/* {!defaultValues.prefilled ? (
								<Controller
									name={FORM_FEE.AMOUNT}
									control={control}
									rules={{
										required: 'Zadejte částku v CZK.',
										min: { value: 1, message: 'Zadejte částku v CZK' },
									}}
									render={({ field }) => (
										<InputPrice
											placeholder="0"
											width={164}
											value={field.value}
											onChange={field.onChange}
											error={!!errors[FORM_FEE.AMOUNT]}
											isVAT={defaultValues.fee_vat}
										/>
									)}
								/>
							) : (
								<PrefilledValuePrice
									price={defaultValues[FORM_FEE.AMOUNT]}
									isVAT={defaultValues.fee_vat}
								/>
							)} */}
						</FormControl>
					</FormLine>

					<FormLine>
						<FormControl
							required
							label="Cestovné"
							htmlFor={FORM_FEE.TRAVEL}
							labelWidth={labelWidth}
							error={errors[FORM_FEE.TRAVEL]}
						>
							<PrefilledValuePrice
								price={defaultValues[FORM_FEE.TRAVEL]}
								isVAT={defaultValues.fee_vat}
							/>
							{/* {!defaultValues.prefilled ? (
								<Controller
									name={FORM_FEE.TRAVEL}
									control={control}
									rules={{
										required: 'Zadejte částku v CZK.',
										min: { value: 0, message: 'Zadejte částku v CZK' },
									}}
									render={({ field }) => (
										<InputPrice
											placeholder="0"
											width={164}
											value={field.value}
											onChange={field.onChange}
											error={!!errors[FORM_FEE.AMOUNT]}
											isVAT={defaultValues.fee_vat}
										/>
									)}
								/>
							) : (
								<PrefilledValuePrice
									price={defaultValues[FORM_FEE.TRAVEL]}
									isVAT={defaultValues.fee_vat}
								/>
							)} */}
						</FormControl>
					</FormLine>

					<FormLine>
						<FormControl label="Celkem" labelWidth={labelWidth}>
							<PriceSummary total={priceTotal} isVat={defaultValues.fee_vat} />
						</FormControl>
					</FormLine>
				</>
			)}

			{feeType === FEE_TYPE.OTHER && (
				<FormLine>
					<FormControl
						required
						label="Popis"
						htmlFor={FORM_FEE.OTHER}
						labelWidth={labelWidth}
						error={errors[FORM_FEE.OTHER]}
					>
						<PreffiledValue>{defaultValues[FORM_FEE.OTHER]}</PreffiledValue>
						{/* {!defaultValues.prefilled ? (
							<Textarea
								placeholder="Zadejte podmínky..."
								{...register(FORM_FEE.OTHER, { required: 'Zadejte podmínky.' })}
								error={!!errors[FORM_FEE.OTHER]}
							/>
						) : (
							<PreffiledValue>{defaultValues[FORM_FEE.OTHER]}</PreffiledValue>
						)} */}
					</FormControl>
				</FormLine>
			)}

			<FormLine>
				<FormControl
					required
					label="Způsob platby"
					htmlFor={FORM_FEE.PAYMENT_TYPE}
					labelWidth={labelWidth}
					error={errors[FORM_FEE.PAYMENT_TYPE]}
					spaceMedium
				>
					<Controller
						name={FORM_FEE.PAYMENT_TYPE}
						control={control}
						defaultValue={paymentTypeOptions[0].value}
						render={({ field }) => {
							return <Radios options={paymentTypeOptions} {...field} />;
						}}
					/>
				</FormControl>
			</FormLine>

			<FormSectionHeading>Vyplácí</FormSectionHeading>

			<FormLine first>
				<FormControl
					required
					label="Jméno"
					htmlFor={FORM_FEE.PAYING_NAME}
					labelWidth={labelWidth}
					error={errors[FORM_FEE.PAYING_NAME]}
				>
					<Input
						placeholder="Zadejte celé jméno..."
						{...register(
							FORM_FEE.PAYING_NAME,
							nonEmptyValidation({ required: 'Zadejte celé jméno vyplácejícího.' }),
						)}
						error={!!errors[FORM_FEE.PAYING_NAME]}
					/>
				</FormControl>
			</FormLine>

			<FormLine>
				<FormControl
					required
					label="E-mail"
					htmlFor={FORM_FEE.PAYING_EMAIL}
					labelWidth={labelWidth}
					error={errors[FORM_FEE.PAYING_EMAIL]}
				>
					<Input
						icon={<IconEmail />}
						{...register(
							FORM_FEE.PAYING_EMAIL,
							emailValidation({ required: 'Zadejte e-mail vyplácejícího.' }),
						)}
						error={!!errors[FORM_FEE.PAYING_EMAIL]}
						width={240}
					/>
				</FormControl>
			</FormLine>

			<FormFooter>
				<Button outline type="button" onClick={() => goPrevStep()}>
					Zpět
				</Button>
				<Button type="submit" isProcessing={updateDataFee.fetching}>
					Uložit a pokračovat
				</Button>
			</FormFooter>
		</form>
	);
};
